import React, { useState, useEffect } from 'react';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Blog from './pages/Blog';
import Category from './pages/Category';
import Comments from './pages/Comments';
import ContactMessages from './pages/ContactMessages';
import About from './pages/About';
import Contact from './pages/Contact';
import Media from './pages/Media';
import Social from './pages/Social';
import CustomPages from './pages/CustomPages';
import FAQ from './pages/FAQ';
import Testimonial from './pages/Testimonial';
import Landing from './pages/Landing';
import Consultants from './pages/Consultants';
import Events from './pages/Events';
import AuthManagement from './pages/AuthManagement';
import ChangePassword from './pages/ChangePassword';
import { Toaster } from 'react-hot-toast';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Badge from '@mui/material/Badge';
import LogoutIcon from '@mui/icons-material/Logout';
import DashboardIcon from '@mui/icons-material/Dashboard';
import ArticleIcon from '@mui/icons-material/Article';
import CategoryIcon from '@mui/icons-material/Category';
import CommentIcon from '@mui/icons-material/Comment';
import InfoIcon from '@mui/icons-material/Info';
import ContactPhoneIcon from '@mui/icons-material/ContactPhone';
import PermMediaIcon from '@mui/icons-material/PermMedia';
import ShareIcon from '@mui/icons-material/Share';
import HomeIcon from '@mui/icons-material/Home';
import PagesIcon from '@mui/icons-material/Pages';
import SettingsIcon from '@mui/icons-material/Settings';
import SmartButtonIcon from '@mui/icons-material/SmartButton';
import EmailIcon from '@mui/icons-material/Email';
import PeopleIcon from '@mui/icons-material/People';
import EventIcon from '@mui/icons-material/Event';
import PersonIcon from '@mui/icons-material/Person';
import LockIcon from '@mui/icons-material/Lock';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { Routes, Route, useNavigate, useLocation } from 'react-router-dom';
import PageEditor from './pages/PageEditor';
import Settings from './pages/Settings';
import HeaderButtons from './pages/HeaderButtons';
import axios from 'axios';
import { getApiUrl } from './config';

const menuItems = [
  { key: 'dashboard', label: 'داشبورد', icon: <DashboardIcon /> },
  { key: 'blog', label: 'مدیریت بلاگ', icon: <ArticleIcon /> },
  { key: 'category', label: 'دسته‌بندی‌های بلاگ', icon: <CategoryIcon /> },
  { key: 'comments', label: 'نظرات بلاگ', icon: <CommentIcon /> },
  { key: 'contact-messages', label: 'پیام‌های تماس', icon: <ContactPhoneIcon /> },
  { key: 'landing', label: 'لندینگ پیج', icon: <HomeIcon /> },
  { key: 'consultants', label: 'مشاوران', icon: <PeopleIcon /> },
  { key: 'events', label: 'رویدادها و کارگاه‌ها', icon: <EventIcon /> },
  { key: 'auth-management', label: 'مدیریت کاربران', icon: <PersonIcon /> },
  { key: 'about', label: 'درباره ما', icon: <InfoIcon /> },
  { key: 'contact', label: 'تماس با ما', icon: <ContactPhoneIcon /> },
  { key: 'media', label: 'رسانه‌ها', icon: <PermMediaIcon /> },
  { key: 'social', label: 'شبکه‌های اجتماعی', icon: <ShareIcon /> },
  { key: 'custom-pages', label: 'صفحات سفارشی', icon: <PagesIcon /> },
  { key: 'faq', label: 'سوالات متداول', icon: <InfoIcon /> },
  { key: 'testimonial', label: 'نظرات مشتریان', icon: <InfoIcon /> },
  { key: 'settings', label: 'تنظیمات سایت', icon: <SettingsIcon /> },
  { key: 'header-buttons', label: 'دکمه‌های هدر', icon: <SmartButtonIcon /> },
];

function MainApp() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [unreadMessagesCount, setUnreadMessagesCount] = useState(0);
  const [anchorEl, setAnchorEl] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (localStorage.getItem('token')) {
      setIsLoggedIn(true);
      fetchUnreadMessagesCount();
      
      // به‌روزرسانی هر 2 دقیقه
      const interval = setInterval(fetchUnreadMessagesCount, 120000);
      
      return () => clearInterval(interval);
    }
  }, []);

  const fetchUnreadMessagesCount = async () => {
    try {
      const token = localStorage.getItem('token');
      if (!token) return;
      
      const response = await axios.get(getApiUrl('/api/contact-messages/unread/count'), {
        headers: { Authorization: `Bearer ${token}` }
      });
      setUnreadMessagesCount(response.data.count);
    } catch (error) {
      console.error('Error fetching unread messages count:', error);
    }
  };

  if (!isLoggedIn) {
    return <Login onLogin={() => setIsLoggedIn(true)} />;
  }

  const handleDrawerToggle = () => setDrawerOpen(!drawerOpen);
  
  const handleProfileMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleProfileMenuClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    setIsLoggedIn(false);
  };

  const handleMenuClick = (key) => {
    let path = '/';
    switch (key) {
      case 'dashboard': path = '/'; break;
      case 'blog': path = '/blog'; break;
      case 'category': path = '/category'; break;
      case 'comments': path = '/comments'; break;
      case 'contact-messages': 
        path = '/contact-messages'; 
        // به‌روزرسانی تعداد پیام‌های نخوانده هنگام ورود به صفحه پیام‌ها
        setTimeout(() => fetchUnreadMessagesCount(), 100);
        break;
      case 'landing': path = '/landing'; break;
      case 'consultants': path = '/consultants'; break;
      case 'events': path = '/events'; break;
      case 'auth-management': path = '/auth-management'; break;
      case 'about': path = '/about'; break;
      case 'contact': path = '/contact'; break;
      case 'media': path = '/media'; break;
      case 'social': path = '/social'; break;
      case 'custom-pages': path = '/custom-pages'; break;
      case 'faq': path = '/faq'; break;
      case 'testimonial': path = '/testimonial'; break;
      case 'settings': path = '/settings'; break;
      case 'header-buttons': path = '/header-buttons'; break;
      default: path = '/';
    }
    navigate(path);
    setDrawerOpen(false);
  };

  return (
    <Box sx={{ display: 'flex', minHeight: '100vh', bgcolor: '#f8fafc', fontFamily: 'Vazir', direction: 'rtl' }}>
      <Toaster position="top-center" reverseOrder={false} />
      {/* AppBar */}
      <AppBar position="fixed" sx={{ zIndex: (theme) => theme.zIndex.drawer + 1, bgcolor: 'primary.main', boxShadow: 2, fontFamily: 'Vazir', direction: 'rtl' }}>
        <Toolbar sx={{ direction: 'rtl' }}>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="end"
            onClick={handleDrawerToggle}
            sx={{ mr: 2, display: { md: 'none' } }}
          >
            <MenuIcon />
          </IconButton>
          <Typography variant="h6" noWrap component="div" sx={{ flexGrow: 1, fontWeight: 'bold', fontFamily: 'Vazir', textAlign: 'right' }}>
            پنل مدیریت سایت
          </Typography>
          
          {/* نمایش تعداد پیام‌های نخوانده */}
          {unreadMessagesCount > 0 && (
            <Badge badgeContent={unreadMessagesCount} color="error" sx={{ ml: 2 }}>
              <EmailIcon sx={{ color: 'white', fontSize: 24 }} />
            </Badge>
          )}
          
          {/* دکمه تنظیمات */}
          <IconButton
            color="inherit"
            onClick={() => navigate('/settings')}
            sx={{ ml: 2 }}
            title="تنظیمات سایت"
          >
            <SettingsIcon />
          </IconButton>
          
          {/* Profile Menu */}
          <IconButton
            color="inherit"
            onClick={handleProfileMenuOpen}
            sx={{ mr: 2 }}
          >
            <AccountCircleIcon />
          </IconButton>
          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleProfileMenuClose}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'right',
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
            sx={{ fontFamily: 'Vazir' }}
          >
            <MenuItem onClick={() => { handleProfileMenuClose(); navigate('/change-password'); }} sx={{ fontFamily: 'Vazir' }}>
              <LockIcon sx={{ mr: 1 }} />
              تغییر رمز عبور
            </MenuItem>
            <MenuItem onClick={handleLogout} sx={{ fontFamily: 'Vazir' }}>
              <LogoutIcon sx={{ mr: 1 }} />
              خروج
            </MenuItem>
          </Menu>
        </Toolbar>
      </AppBar>
      {/* Drawer (Sidebar) */}
      <Drawer
        variant="permanent"
        anchor="right"
        sx={{
          width: 220,
          flexShrink: 0,
          [`& .MuiDrawer-paper`]: {
            width: 220,
            boxSizing: 'border-box',
            bgcolor: 'primary.light',
            borderLeft: 0,
            borderRight: 0,
            display: { xs: 'none', md: 'block' },
            borderRadius: 3,
            boxShadow: 3,
            p: 0,
            direction: 'rtl',
            textAlign: 'right',
            fontFamily: 'Vazir !important',
            '& .MuiListItemText-root, & .MuiListItemButton-root, & .MuiTypography-root': {
              fontFamily: 'Vazir !important',
            },
          },
          display: { xs: 'none', md: 'block' },
          direction: 'rtl',
        }}
        open
      >
        <Toolbar />
        <Box sx={{ overflow: 'auto', pt: 2, fontFamily: 'Vazir' }}>
          <List sx={{ fontFamily: 'Vazir' }}>
            {menuItems.map((item) => (
              <ListItem key={item.key} disablePadding sx={{ mb: 1, fontFamily: 'Vazir' }}>
                <ListItemButton selected={location.pathname === `/${item.key}`} onClick={() => handleMenuClick(item.key)}
                  sx={{
                    borderRadius: 2,
                    mx: 1,
                    bgcolor: location.pathname === `/${item.key}` ? 'primary.main' : 'primary.light',
                    color: location.pathname === `/${item.key}` ? '#fff' : 'primary.dark',
                    '&:hover': { bgcolor: 'primary.main', color: '#fff' },
                    display: 'flex',
                    flexDirection: 'row-reverse',
                    alignItems: 'center',
                    direction: 'rtl',
                    textAlign: 'right',
                    fontFamily: 'Vazir',
                  }}
                >
                  {item.icon}
                  <ListItemText
                    primary={item.label}
                    sx={{
                      textAlign: 'right',
                      fontFamily: 'Vazir',
                      mr: 2,
                      fontWeight: location.pathname === `/${item.key}` ? 'bold' : 'normal',
                    }}
                  />
                </ListItemButton>
              </ListItem>
            ))}
          </List>
        </Box>
      </Drawer>
      {/* Drawer (Sidebar) for mobile */}
      <Drawer
        variant="temporary"
        anchor="right"
        open={drawerOpen}
        onClose={handleDrawerToggle}
        ModalProps={{ keepMounted: true }}
        sx={{
          display: { xs: 'block', md: 'none' },
          '& .MuiBackdrop-root': {
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
          },
          [`& .MuiDrawer-paper`]: {
            width: 220,
            boxSizing: 'border-box',
            bgcolor: 'primary.light',
            borderLeft: 0,
            borderRight: 0,
            borderRadius: '0 0 0 12px',
            boxShadow: 3,
            p: 0,
            direction: 'rtl',
            textAlign: 'right',
            fontFamily: 'Vazir !important',
            '& .MuiListItemText-root, & .MuiListItemButton-root, & .MuiTypography-root': {
              fontFamily: 'Vazir !important',
            },
          },
          direction: 'rtl',
        }}
      >
        <Toolbar />
        <Box sx={{ overflow: 'auto', pt: 2, fontFamily: 'Vazir' }}>
          <List sx={{ fontFamily: 'Vazir' }}>
            {menuItems.map((item) => (
              <ListItem key={item.key} disablePadding sx={{ mb: 1, fontFamily: 'Vazir' }}>
                <ListItemButton selected={location.pathname === `/${item.key}`} onClick={() => handleMenuClick(item.key)}
                  sx={{
                    borderRadius: 2,
                    mx: 1,
                    bgcolor: location.pathname === `/${item.key}` ? 'primary.main' : 'primary.light',
                    color: location.pathname === `/${item.key}` ? '#fff' : 'primary.dark',
                    '&:hover': { bgcolor: 'primary.main', color: '#fff' },
                    display: 'flex',
                    flexDirection: 'row-reverse',
                    alignItems: 'center',
                    direction: 'rtl',
                    textAlign: 'right',
                    fontFamily: 'Vazir',
                  }}
                >
                  {item.icon}
                  <ListItemText
                    primary={item.label}
                    sx={{
                      textAlign: 'right',
                      fontFamily: 'Vazir',
                      mr: 2,
                      fontWeight: location.pathname === `/${item.key}` ? 'bold' : 'normal',
                    }}
                  />
                </ListItemButton>
              </ListItem>
            ))}
          </List>
        </Box>
      </Drawer>
      {/* Main Content */}
      <Box component="main" sx={{ flexGrow: 1, p: { xs: 2, md: 4 }, mt: 8, width: { xs: '100%', md: `calc(100% - 220px)` }, direction: 'rtl', textAlign: 'right' }}>
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/category" element={<Category />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/media" element={<Media />} />
          <Route path="/social" element={<Social />} />
          <Route path="/custom-pages" element={<CustomPages />} />
          <Route path="/custom-pages/:id" element={<PageEditor />} />
          <Route path="/admin/page-editor/:section" element={<PageEditor />} />
          <Route path="/custom-pages/page-editor/:section" element={<PageEditor />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/testimonial" element={<Testimonial />} />
          <Route path="/landing" element={<Landing />} />
          <Route path="/consultants" element={<Consultants />} />
          <Route path="/events" element={<Events />} />
          <Route path="/auth-management" element={<AuthManagement />} />
          <Route path="/settings" element={<Settings />} />
          <Route path="/header-buttons" element={<HeaderButtons />} />
          <Route path="/comments" element={<Comments />} />
          <Route path="/contact-messages" element={<ContactMessages />} />
          <Route path="/change-password" element={<ChangePassword />} />
        </Routes>
      </Box>
    </Box>
  );
}

export default MainApp; 